import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "./header";
import { Footer } from "./footer";
import "./Gallery.css";

export const Gallery = () => {
  const portfolioCategories = [
    {
      title: "Weddings",
      subtitle: "Timeless moments of love and celebration",
      image: "/resources/images/wedding/wedding-portfolio39.jpg",
      description: "Elegant mandap architecture with flowing fabrics and subtle floral elements in watercolor",
      link: "/portfolio/weddings"
    },
    {
      title: "Birthday Parties",
      subtitle: "Capturing joy and milestones",
      image: "/resources/images/birthday16.jpeg",
      description: "Whimsical scene with floating balloons and delicate party elements in soft pastels",
      link: "/portfolio/birthdays"
    },
    {
      title: "Social Soirées",
      subtitle: "Elegant evening gatherings",
      image: "/resources/images/cocktail/img14.jpg",
      description: "Sophisticated cityscape with champagne flutes and subtle evening lighting",
      link: "/portfolio/cocktail"
    },
    {
      title: "Corporate & Social Impact",
      subtitle: "Professional excellence and meaningful moments",
      image: "/resources/images/celebrity/celeb1.jpg",
      description: "Modern architectural elements with clean lines and community-focused atmosphere",
      link: "/portfolio/corporate-social"
    },
    {
      title: "Food & Beverage",
      subtitle: "Culinary artistry in focus",
      image: "/resources/images/f&b/f&b80.jpg",
      description: "Artistic composition of culinary masterpieces with perfect lighting and styling",
      link: "/portfolio/food-beverage"
    }
  ];

  return (
    <div className="portfolio-page">
      <Navbar />
      
      {/* Hero Section */}
      <section className="portfolio-hero">
        <h1 className="portfolio-hero-title">Our Portfolio</h1>
        <div className="title-line"></div>
        <p className="portfolio-hero-subtitle">A Collection of Moments That Tell Stories</p>
      </section>

      {/* Categories Grid */}
      <section className="portfolio-categories">
        <div className="categories-grid">
          {portfolioCategories.map((category, index) => (
            <Link to={category.link} key={index} className="category-card">
              <div className="category-image">
                <img src={category.image} alt={category.title} />
                <div className="category-overlay"></div>
              </div>
              <div className="category-content">
                <h2>{category.title}</h2>
                <p>{category.subtitle}</p>
                <span className="view-more">View Gallery</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Quote Section */}
      <section className="portfolio-quote">
        <div className="quote-content">
          <blockquote>
            "Every event tells a unique story. We're here to capture yours in its most authentic form."
          </blockquote>
          <div className="quote-author">- Stories by Kalakaar</div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
